jQuery(function ($) {
    $(document).ready(function() {
        if ($('#commentform #comment-email').length) {

            $.ajax( {
                url      : themevars.ajaxurl,
                data     : {
                    action: 'comment_account_email',
                    cac_nonce: themevars.cac_nonce
                },
                type     : 'POST',
                dataType : 'json'
            } ).done( function ( response ) {
    
                if (true !== response.success || !response.data.is_logged_in) {
                    $('.single-video .post-comment-mobile').remove();
                    $('.single-video .comment-form-wrapper').remove();
                    $('.single-video .comment-login-required-text').removeClass('d-none');
                    return;
                }
    
                if (response.data.is_logged_in && response.data.emailaddress) {
                    // set emailaddress as value of comment email field and set field to disabled
                    $('#commentform #comment-email').val(response.data.emailaddress);
                    $("#commentform #comment-email").prop("readonly", true);
                }
            });
        }

        let elements = document.querySelector('.post-comment-mobile');

        if (elements) {
            elements.addEventListener('click', function (e) {
                e.preventDefault();

                const form = document.getElementById('comment-form');
                const isOpen = form.classList.toggle('is-open');

                this.setAttribute('aria-expanded', isOpen);
            });
        }
    });
});
